import { render, staticRenderFns } from "./eventStatic.vue?vue&type=template&id=74f0a0ce&scoped=true"
import script from "./eventStatic.vue?vue&type=script&lang=js"
export * from "./eventStatic.vue?vue&type=script&lang=js"
import style0 from "./eventStatic.vue?vue&type=style&index=0&id=74f0a0ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f0a0ce",
  null
  
)

export default component.exports